//import documentTypesValueLabelList from '../../catalogs'

import { formTypes } from '.';
import { arlsValueLabelList } from '../../catalogs/arls';
import { colombianCitieslabelLabelList } from '../../catalogs/colombianCities';
import { documentTypesValueAbreviationList, documentTypesValueLabelList } from '../../catalogs/documentTypes';
import { iso3166CountrieslabelLabelList } from '../../catalogs/ISO3166Countries';
import { personTypesValueLabelList } from '../../catalogs/personTypes';
import { regimesValueLabelList } from '../../catalogs/regimes';
import { accountSubTypeValueLabelList, sourceAccountsValueLabelList } from '../banks';
// TODO crear su client
export const businessFields = {
  name: {
    key: 'name',
    label: 'Nombre',
    show: value => value.typeOfPerson !== '1' || value.typeOfPerson === undefined,
    placeholder: 'Juan Andrés'
  },
  contactName: {
    key: 'contactName',
    label: 'Nombre contacto directo',
    placeholder: 'Juan Andrés Rodríguez Pérez'
  },
  businessName: {
    key: 'businessName',
    label: 'Razón social',
    show: value => value.typeOfPerson === '1',
    placeholder: 'Republic Motors Incorporation'
  },
  lastName: {
    key: 'lastName',
    label: 'Apellido',
    show: value => value.typeOfPerson !== '1' || value.typeOfPerson === undefined,
    placeholder: 'Rodríguez Pérez'
  },
  /*  identificationType: {
    key: 'identificationType',
    label: 'Tipo de identificación',
    type: formTypes.select,
    options: documentTypesValueLabelList
    //show: value => value.typeOfPerson !== '1'
  }, */
  identificationNumber: {
    keyType: 'identificationType',
    optionsType: documentTypesValueAbreviationList,
    key: 'identificationNumber',
    label: 'Identificación',
    type: formTypes.identification,
    popover: 'Si eres persona jurídica, el NIT debe tener 10 caracteres (CON dígito de verificación, sin guión)',
    placeholder: '30000000',
    textHelper: 'Verifica el tipo de documento antes de continuar'
  },
  regime: {
    key: 'regime',
    label: 'Régimen',
    type: formTypes.select,
    options: regimesValueLabelList
    // show: value => value.typeOfPerson === '1'
  },
  email: {
    key: 'email',
    label: 'Correo general',
    validate: true,
    popover: 'Este correo será utilizado para notificarte sobre los eventos que ocurran en tu cuenta de melo.',
    placeholder: 'hola@ejemplo.com'
  },
  address: { key: 'address', label: 'Dirección', placeholder: 'Calle 97 #72-107' },
  phone: {
    keyIndicative: 'phoneIndicative',
    key: 'phone',
    label: 'Teléfono o celular',
    type: formTypes.phone,
    placeholder: '30000000'
  },
  businessPhone: {
    keyIndicative: 'phoneIndicative',
    key: 'businessPhone',
    label: 'Teléfono de la empresa',
    type: formTypes.phone,
    placeholder: '30000000'
  },
  /* phoneIndicative: { key: 'phoneIndicative', label: 'Teléfono indicativo', type: formTypes.select, options: indicativePhone }, */
  country: { key: 'country', label: 'País', type: formTypes.select, options: iso3166CountrieslabelLabelList },
  city: { key: 'city', label: 'Ciudad', type: formTypes.select, options: colombianCitieslabelLabelList },
  typeOfContributor: { key: 'typeOfContributor', label: 'Tipo de aportante' },
  contributorClass: { key: 'contributorClass', label: 'Clase de aportante' },
  typeOfPerson: { key: 'typeOfPerson', label: 'Naturaleza jurídica', type: formTypes.select, options: personTypesValueLabelList },
  legalNature: { key: 'legalNature', label: 'Naturaleza Jurídica' },
  occupationalRiskManager: {
    key: 'occupationalRiskManager',
    label: 'Administradora riesgos laborales',
    type: formTypes.select,
    options: arlsValueLabelList
  },
  mainEconomicActivity: { key: 'mainEconomicActivity', label: 'Actividad economica principal' }
};

export const bankInfoBusiness = {
  infoUser: {
    key: 'infoUser',
    label: '',
    type: formTypes.checkbox,
    options: [{ key: 'yes', label: '¿La información del titular de la cuenta coincide con la información general del negocio?' }],
    cols: 2
  },
  bankId: { key: 'paymentdruoBankId', label: 'Banco', type: formTypes.selectComplete, options: sourceAccountsValueLabelList },
  bankAccountNumber: { key: 'paymentbankAccountNumber', label: 'Número de cuenta', type: formTypes.text, placeholder: '9000000' },
  bankAccountSubtype: {
    key: 'paymentdruoBankAccountSubtype',
    label: 'Tipo de cuenta',
    type: formTypes.select,
    options: accountSubTypeValueLabelList
  },
  typeOfPerson: {
    key: 'paymentTypeOfPerson',
    label: 'Naturaleza jurídica',
    type: formTypes.select,
    options: personTypesValueLabelList
  },
  name: { key: 'paymentName', label: 'Nombre', placeholder: 'Juan Andrés' },
  lastName: {
    key: 'paymentLastName',
    label: 'Apellido',
    show: value => value.paymentTypeOfPerson !== '1' || value.paymentTypeOfPerson === undefined,
    placeholder: 'Rodríguez Pérez'
  },
  businessName: {
    key: 'paymentBusinessName',
    label: 'Razón social',
    show: value => value.paymentTypeOfPerson === '1',
    placeholder: 'Republic Motors Incorporation'
  },

  /*   identificationType: {
    key: 'paymentIdentificationType',
    label: 'Tipo de identificación',
    type: formTypes.select,
    options: documentTypesValueLabelList,
    show: value => value.paymentTypeOfPerson !== '1'
  }, */
  identificationNumber: {
    keyType: 'paymentIdentificationType',
    optionsType: documentTypesValueAbreviationList,
    key: 'paymentIdentificationNumber',
    label: 'Identificación',
    type: formTypes.identification,
    popover: 'Si eres persona jurídica, el NIT debe tener 10 caracteres (CON dígito de verificación, sin guión)',
    placeholder: '300000000',
    textHelper: 'Verifica el tipo de documento antes de continuar'
  },
  country: { key: 'paymentCountry', label: 'País', type: formTypes.select, options: iso3166CountrieslabelLabelList },
  email: { key: 'paymentEmail', label: 'Correo general de empresa', validate: true, placeholder: 'hola@ejemplo.com' }
};

export const legalRepresentantFields = {
  nameComplete: { key: 'nameComplete', label: 'Nombre completo', placeholder: 'Juan Andrés Rodríguez Pérez' },
  identificationType: {
    key: 'legalIdentificationType',
    label: 'Tipo de documento',
    type: formTypes.select,
    options: documentTypesValueLabelList
  },
  identificationNumber: {
    key: 'legalIdentificationNumber',
    label: 'Identificación',
    popover: 'Si eres persona jurídica, el NIT debe tener 10 caracteres (CON dígito de verificación, sin guión)',
    placeholder: '3000000',
    textHelper: 'Verifica el tipo de documento antes de continuar'
  },
  email: { key: 'legalEmail', label: 'Email', validate: true, placeholder: 'hola@ejemplo.com' },
  address: { key: 'legalAddress', label: 'Dirección', placeholder: 'Calle 97 #72-107' },
  phone: { keyIndicative: 'legalPhoneIndicative', key: 'legalPhone', label: 'Teléfono o celular', type: formTypes.phone }
};

const paymentTemporalities = [
  { key: 'BIWEEKLY', value: 'Quincenal' },
  { key: 'MONTHLY', value: 'Mensual' }
];

const selectOptionsMapping = array => array.map(({ key, value }) => ({ value: key, label: value }));
const daysNumbersArray = () => {
  let daysNumbers = {};
  return Array.from({ length: 31 }, (_, i) => (daysNumbers[i + 1] = { value: i + 1, label: i + 1 }));
};

export const temporalityFields = {
  isActive: {
    key: 'isActive',
    label: '¿Deseas que tu nómina se genere de manera automática?',
    type: formTypes.radio,
    options: [
      { key: 'no', label: 'No' },
      { key: 'yes', label: 'Si, deseo que se genere automáticamente' }
    ],
    cols: 2
  },
  temporality: {
    key: 'temporality',
    label: 'Temporalidad de pagos',
    type: formTypes.select,
    show: values => values.isActive === 'yes',
    options: selectOptionsMapping(paymentTemporalities)
  },
  periodStartDay: {
    key: 'periodStartDay',
    label: 'Día de inicio de la nómina',
    type: formTypes.select,
    show: values => values.isActive === 'yes',
    options: daysNumbersArray()
  }
};
